import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { portfolioData } from '../data/mock';

const InspiredBySection = () => {
  const { inspiredBy } = portfolioData;
  const scrollRef = useRef(null);
  
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-24">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-2">
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(235, 240, 250, 0.95)', fontWeight: 400 }}>{inspiredBy.heading}</h2>
        </motion.div>
        
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} className="text-center mb-8 sm:mb-10 md:mb-12" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.7)', fontSize: '0.85rem' }}>
          {inspiredBy.subtitle}
        </motion.p>
        
        <div ref={scrollRef} className="flex gap-4 sm:gap-6 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollSnapType: 'x mandatory' }}>
          {inspiredBy.quotes.map((quote, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.03, y: -4 }}
              className="glass-panel p-6 sm:p-8 min-w-[280px] sm:min-w-[320px] md:min-w-[380px] flex-shrink-0 relative cursor-default"
              style={{ scrollSnapAlign: 'start' }}
            >
              <span className="absolute top-4 left-4 sm:left-6 text-5xl sm:text-6xl leading-none" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(180, 195, 220, 0.12)' }}>"</span>
              <blockquote className="pt-6 sm:pt-8 mb-4 sm:mb-6" style={{ fontFamily: 'EB Garamond, serif', fontStyle: 'italic', color: 'rgba(220, 230, 245, 0.9)', fontSize: '0.95rem', lineHeight: '1.7' }}>
                {quote.text}
              </blockquote>
              <p className="text-right text-xs sm:text-sm" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.6)', fontSize: '0.75rem' }}>— {quote.source}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InspiredBySection;
